import { render, staticRenderFns } from "./LeadsNew.vue?vue&type=template&id=34f49658&scoped=true"
import script from "./LeadsNew.vue?vue&type=script&lang=js"
export * from "./LeadsNew.vue?vue&type=script&lang=js"
import style0 from "./LeadsNew.vue?vue&type=style&index=0&id=34f49658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f49658",
  null
  
)

export default component.exports